<template>
  <div class="d-flex flex-column h-100">
    <div class="flex-shrink-0">
      <b-navbar toggleable="xl" type="dark" variant="danger">
        <b-navbar-brand :to="{ name: 'AppStart' }">N2ushoorn</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav v-if="staffSiteEnabled">
            <b-nav-item exact-active-class="active" :to="{ name: 'StaffHome' }">Bestuursdashboard</b-nav-item>
            <b-nav-item active-class="active" :to="{ name: 'ActivitiesSheet' }">Lubsheet</b-nav-item>
            <b-nav-item active-class="active" :to="{ name: 'ListActivities' }">Activiteiten</b-nav-item>
            <b-nav-item active-class="active" :to="{ name: 'ListPersonnel' }">Rino'ers</b-nav-item>
            <b-nav-item active-class="active" :to="{ name: 'ListClients' }">Opdrachtgevers</b-nav-item>
            <b-nav-item active-class="active" :to="{ name: 'Statistics' }">Statistieken</b-nav-item>
            <b-nav-item active-class="active" :to="{ name: 'StatementsOfCostsOverview' }">Declaraties</b-nav-item>
          </b-navbar-nav>

          <UserNavbar></UserNavbar>
        </b-collapse>
      </b-navbar>

      <router-view v-if="staffSiteEnabled || route === 'GlobalSettings'" class="body-style"/>
      <b-container v-else class="mt-2">
        <b-jumbotron>
          <h6>De <code>Bestuur</code> app is op dit moment uitgeschakeld...</h6>
          <hr/>
          <p>
            De systeembeheerders hebben de bestuursapp in N2ushoorn uitgeschakeld.

            <br>

            <small class="text-muted">De N2ushoorn app kan weer worden ingeschakeld door <code>staff_app_enabled</code> in te schakelen in de systeeminstellingen.</small>
          </p>
        </b-jumbotron>
      </b-container>
    </div>
    <n2ushoornFooter
        :contact-info-ready="contactInfoReady"
        :public-contact-and-location-information="publicContactAndLocationInformation"
    />
  </div>
</template>

<script>
import UserNavbar from "@/components/UserNavbar";
import n2ushoornFooter from "@/components/n2ushoornFooter";

export default {
  name: "StaffHome",
  components: {
    UserNavbar,
    n2ushoornFooter
  },
  props: {
    publicContactAndLocationInformation: Object,
    statusInformation: Object,
    contactInfoReady: Boolean,
  },
  computed: {
    staffSiteEnabled() {
      return this.statusInformation === null ? false : this.statusInformation.staff_app_enabled;
    },
    route() {
      return this.$route.name
    }
  }
}
</script>

<style scoped>
.body-style {
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>